module.exports = __webpack_public_path__ + "img/saroush-barazesh-kings-of-nowhere.b0e9a55.jpg";